__webpack_require__.p = "/mokasoftwares/";